export const TABS = {
	partners: { value: 'partners', text: 'partner services' },
	unpaid: { value: 'unpaid', text: 'unpaid services' },
	paid: { value: 'paid', text: 'paid services' },
	technicianPay: { value: 'technicianPayment', text: 'technician payment' }
};
